(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rh-bfw-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-bfw-solo-offer]').forEach((container) => {
      if (container.dataset.bfwSoloInitialized) return;
      container.dataset.bfwSoloInitialized = 'true';
      const parseDeadline = (value) => {
        const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
        if (!match) return NaN;
        const [, year, month, day, hour, minute, second, zone] = match;
        const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
        if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() + 1 !== Number(month) || date.getUTCDate() !== Number(day) || date.getUTCHours() !== Number(hour) || date.getUTCMinutes() !== Number(minute) || date.getUTCSeconds() !== Number(second)) return NaN;
        if (zone !== 'Z') {
          if (Number(zone.slice(1, 3)) > 14 || Number(zone.slice(4, 6)) > 59) return NaN;
          if (Number(zone.slice(1, 3)) === 14 && Number(zone.slice(4, 6)) !== 0) return NaN;
        }
        return Date.parse(value);
      };
      const hideAt = parseDeadline(container.dataset.offerHideAt);
      const countdownEnd = parseDeadline(container.dataset.countdownEnd);
      const timer = container.querySelector('[data-countdown-wrap]');
      const numbers = container.querySelectorAll('[data-bfw-solo-countdown] .cd-number');
      let interval;
      const cleanup = () => {
        clearInterval(interval);
        window.removeEventListener('pageshow', update);
        document.removeEventListener('visibilitychange', update);
      };
      const update = () => {
        if (!container.isConnected) {
          cleanup();
          return;
        }
        const now = Date.now();
        if (!Number.isFinite(hideAt) || !Number.isFinite(countdownEnd) || hideAt < countdownEnd || now >= hideAt) {
          container.remove();
          cleanup();
          return;
        }
        if (!Number.isFinite(countdownEnd) || now >= countdownEnd) {
          if (timer) timer.hidden = true;
          return;
        }
        const seconds = Math.floor((countdownEnd - now) / 1000);
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        numbers.forEach((number, index) => { number.textContent = String(values[index]).padStart(2, '0'); });
      };
      update();
      if (!container.isConnected) return;
      interval = setInterval(update, 1000);
      window.addEventListener('pageshow', update);
      document.addEventListener('visibilitychange', update);
    });
    scope.querySelectorAll('[data-bfw-media]').forEach((container) => {
      if (container.dataset.bfwInitialized) return;
      container.dataset.bfwInitialized = 'true';
      const video = container.querySelector('[data-bfw-video]');
      const image = container.querySelector('.rh-bfw__product-image');
      const button = container.querySelector('[data-bfw-play]');
      if (!video || !image || !button || !container.dataset.videoUrl) return;
      const restore = () => {
        video.hidden = true;
        image.hidden = false;
        button.hidden = false;
        button.disabled = false;
      };
      const play = () => {
        button.disabled = true;
        video.muted = true;
        video.loop = true;
        if (!video.getAttribute('src')) video.src = container.dataset.videoUrl;
        video.play().catch(restore);
      };
      video.addEventListener('playing', () => {
        image.hidden = true;
        video.hidden = false;
        button.hidden = true;
        button.disabled = false;
      });
      button.addEventListener('click', play);
      video.addEventListener('pause', restore);
      video.addEventListener('ended', restore);
      video.addEventListener('error', restore);
      window.addEventListener('pagehide', () => video.pause(), { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-newsletter-pax"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseISO = (value) => {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
      if (!match) return NaN;
      const [, year, month, day, hour, minute, second, zone] = match;
      const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
      if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() + 1 !== Number(month) || date.getUTCDate() !== Number(day) || date.getUTCHours() !== Number(hour) || date.getUTCMinutes() !== Number(minute) || date.getUTCSeconds() !== Number(second)) return NaN;
      if (zone !== 'Z') {
        if (Number(zone.slice(1, 3)) > 14 || Number(zone.slice(4, 6)) > 59) return NaN;
        if (Number(zone.slice(1, 3)) === 14 && Number(zone.slice(4, 6)) !== 0) return NaN;
      }
      return Date.parse(value);
    };
    const mount = (root) => {
      if (root.dataset.paxMounted) return;
      root.dataset.paxMounted = 'true';
      const timerEnd = parseISO(root.dataset.timerEnd);
      const hideAt = parseISO(root.dataset.hideAt);
      if (!Number.isFinite(timerEnd) || !Number.isFinite(hideAt) || hideAt < timerEnd) {
        root.remove();
        return;
      }
      const countdown = root.querySelector('[data-pax-countdown]');
      const units = ['days', 'hours', 'minutes', 'seconds'].map((unit) => root.querySelector(`[data-pax-${unit}]`));
      let interval;
      const stop = () => {
        root.querySelector('[data-pax-launch-video]')?.pause();
        window.clearInterval(interval);
        window.removeEventListener('pageshow', tick);
        document.removeEventListener('visibilitychange', tick);
      };
      const tick = () => {
        if (!root.isConnected) {
          stop();
          return;
        }
        const now = Date.now();
        if (now >= hideAt) {
          root.remove();
          stop();
          return;
        }
        if (root.hidden) {
          root.hidden = false;
          window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
        }
        if (!countdown) return;
        if (now >= timerEnd) {
          countdown.hidden = true;
          return;
        }
        const seconds = Math.ceil((timerEnd - now) / 1000);
        const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
        units.forEach((element, index) => {
          if (element) element.textContent = index === 0 ? String(values[index]) : String(values[index]).padStart(2, '0');
        });
        countdown.hidden = false;
      };
      tick();
      if (!root.isConnected) return;
      interval = window.setInterval(tick, 1000);
      window.addEventListener('pageshow', tick);
      document.addEventListener('visibilitychange', tick);
    };
    const mountAll = (scope) => {
      if (scope.matches?.('[data-rh-newsletter-pax]')) mount(scope);
      scope.querySelectorAll('[data-rh-newsletter-pax]').forEach(mount);
    };
    mountAll(document);
    document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-newsletter-smono3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseISO = (value) => {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
      if (!match) return NaN;
      const [, year, month, day, hour, minute, second, zone] = match;
      const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
      if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() + 1 !== Number(month) || date.getUTCDate() !== Number(day) || date.getUTCHours() !== Number(hour) || date.getUTCMinutes() !== Number(minute) || date.getUTCSeconds() !== Number(second)) return NaN;
      if (zone !== 'Z') {
        if (Number(zone.slice(1, 3)) > 14 || Number(zone.slice(4, 6)) > 59) return NaN;
        if (Number(zone.slice(1, 3)) === 14 && Number(zone.slice(4, 6)) !== 0) return NaN;
      }
      return Date.parse(value);
    };
    const mount = (root) => {
      if (root.dataset.smono3Mounted) return;
      root.dataset.smono3Mounted = 'true';
      const timerEnd = parseISO(root.dataset.timerEnd);
      const hideAt = parseISO(root.dataset.hideAt);
      if (!Number.isFinite(timerEnd) || !Number.isFinite(hideAt) || hideAt < timerEnd) {
        root.remove();
        return;
      }
      const countdown = root.querySelector('[data-smono3-countdown]');
      const units = ['days', 'hours', 'minutes', 'seconds'].map((unit) => root.querySelector(`[data-smono3-${unit}]`));
      let interval;
      const stop = () => {
        window.clearInterval(interval);
        window.removeEventListener('pageshow', tick);
        document.removeEventListener('visibilitychange', tick);
      };
      const tick = () => {
        if (!root.isConnected) {
          stop();
          return;
        }
        const now = Date.now();
        if (now >= hideAt) {
          root.remove();
          stop();
          return;
        }
        if (root.hidden) {
          root.hidden = false;
          window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
        }
        if (!countdown) return;
        if (now >= timerEnd) {
          countdown.hidden = true;
          return;
        }
        const seconds = Math.ceil((timerEnd - now) / 1000);
        const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
        units.forEach((element, index) => {
          if (element) element.textContent = index === 0 ? String(values[index]) : String(values[index]).padStart(2, '0');
        });
        countdown.hidden = false;
      };
      tick();
      if (!root.isConnected) return;
      interval = window.setInterval(tick, 1000);
      window.addEventListener('pageshow', tick);
      document.addEventListener('visibilitychange', tick);
    };
    const mountAll = (scope) => {
      if (scope.matches?.('[data-rh-newsletter-smono3]')) mount(scope);
      scope.querySelectorAll('[data-rh-newsletter-smono3]').forEach(mount);
    };
    mountAll(document);
    document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-newsletter-solo3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseISO = (value) => {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{3}))?(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
      if (!match) return NaN;
      const [, year, month, day, hour, minute, second, millisecond, zone] = match;
      const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second), Number(millisecond || 0)));
      if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() + 1 !== Number(month) || date.getUTCDate() !== Number(day) || date.getUTCHours() !== Number(hour) || date.getUTCMinutes() !== Number(minute) || date.getUTCSeconds() !== Number(second) || date.getUTCMilliseconds() !== Number(millisecond || 0)) return NaN;
      if (zone !== 'Z') {
        if (Number(zone.slice(1, 3)) > 14 || Number(zone.slice(4, 6)) > 59) return NaN;
        if (Number(zone.slice(1, 3)) === 14 && Number(zone.slice(4, 6)) !== 0) return NaN;
      }
      return Date.parse(value);
    };
    const mount = (root) => {
      if (root.dataset.solo3Mounted) return;
      root.dataset.solo3Mounted = 'true';
      const timerEnd = parseISO(root.dataset.timerEnd);
      const hideAt = parseISO(root.dataset.hideAt);
      const accessUntil = parseISO(root.dataset.accessUntil);
      if (!Number.isFinite(timerEnd) || !Number.isFinite(hideAt) || !Number.isFinite(accessUntil) || accessUntil > hideAt || hideAt < timerEnd) {
        root.remove();
        return;
      }
      const countdown = root.querySelector('[data-solo3-countdown]');
      const units = ['days', 'hours', 'minutes', 'seconds'].map((unit) => root.querySelector(`[data-solo3-${unit}]`));
      let interval;
      const stop = () => {
        window.clearInterval(interval);
        window.removeEventListener('pageshow', tick);
        document.removeEventListener('visibilitychange', tick);
      };
      const tick = () => {
        if (!root.isConnected) {
          stop();
          return;
        }
        const now = Date.now();
        if (now >= hideAt || now >= accessUntil) {
          root.remove();
          stop();
          return;
        }
        if (root.hidden) {
          root.hidden = false;
          window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
        }
        if (!countdown) return;
        if (now >= timerEnd) {
          countdown.hidden = true;
          return;
        }
        const seconds = Math.ceil((timerEnd - now) / 1000);
        const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
        units.forEach((element, index) => {
          if (element) element.textContent = index === 0 ? String(values[index]) : String(values[index]).padStart(2, '0');
        });
        countdown.hidden = false;
      };
      tick();
      if (!root.isConnected) return;
      interval = window.setInterval(tick, 1000);
      window.addEventListener('pageshow', tick);
      document.addEventListener('visibilitychange', tick);
    };
    const mountAll = (scope) => {
      if (scope.matches?.('[data-rh-newsletter-solo3]')) mount(scope);
      scope.querySelectorAll('[data-rh-newsletter-solo3]').forEach(mount);
    };
    mountAll(document);
    document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-newsletter-w3-wrapper"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Kopf und Countdown nur in der ersten noch vorhandenen Angebotssektion zeigen.
    const syncIntro = () => {
      [...document.querySelectorAll('[data-rh-newsletter-w3]')].filter(el => el.isConnected).forEach((el, i) => {
        const intro = el.querySelector('[data-w3-intro]');
        if (intro) intro.hidden = false;
      });
    };
    const mount = (root) => {
      if (root.dataset.w3Mounted) return;
      root.dataset.w3Mounted = 'true';
      const end = Date.parse(root.dataset.end);
      const serverNow = Number(root.dataset.serverNow) * 1000;
      const accessUntil = Number(root.dataset.accessUntil) * 1000;
      const started = performance.now();
      const preview = root.dataset.preview === 'true';
      const units = ['days', 'hours', 'minutes', 'seconds'].map(unit => root.querySelector(`[data-w3-unit="${unit}"]`));
      let interval;
      const stop = () => {
        root.querySelector('[data-w3-video]')?.pause();
        clearInterval(interval);
        window.removeEventListener('pageshow', tick);
        document.removeEventListener('visibilitychange', tick);
      };
      const tick = () => {
        if (!root.isConnected) { stop(); return; }
        const now = Math.max(Date.now(), serverNow + performance.now() - started);
        if (!Number.isFinite(end) || !Number.isFinite(serverNow) || !Number.isFinite(now) || (!preview && (!Number.isFinite(accessUntil) || now >= Math.min(end, accessUntil)))) {
          root.remove(); stop(); syncIntro(); return;
        }
        const seconds = Math.max(0, Math.ceil((end - now) / 1000));
        const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
        units.forEach((el, i) => { if (el) el.textContent = String(values[i]).padStart(2, '0'); });
        root.hidden = false;
        // Go-SRT-Video startet stumm, sobald die Sektion sichtbar ist; nur einmal, damit ein Anhalten nicht überschrieben wird (30.10.2026).
        const video = root.querySelector('[data-w3-video]');
        if (video && !video.dataset.w3Started) {
          video.dataset.w3Started = 'true';
          video.muted = true;
          video.play()?.catch(() => {});
        }
        syncIntro();
      };
      tick();
      if (!root.isConnected) return;
      interval = setInterval(tick, 1000);
      window.addEventListener('pageshow', tick);
      document.addEventListener('visibilitychange', tick);
    };
    const mountAll = scope => {
      if (scope.matches?.('[data-rh-newsletter-w3]')) mount(scope);
      scope.querySelectorAll('[data-rh-newsletter-w3]').forEach(mount);
    };
    mountAll(document);
    document.addEventListener('shopify:section:load', event => mountAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
